import { graphql } from "src/graphql/generated";

export const campaignResultsExportJobsQuery = graphql(/* GraphQL */ `
    query CampaignResultsExportJobs($campaignId: String!, $clientId: String!) {
        campaign(campaignId: $campaignId) {
            id
            resultsExportJobs(clientId: $clientId) {
                ...exportJobFields
            }
        }
    }
`);
